const initialState = {
    bool: false
}

const agencyMatchRed = (state = initialState, action) => {
    switch(action.type){
        case 'AGENCY_MATCH' : {
            return {
                ...state,
                bool: action.bool
            }
        }
        default: {
            return state
        }
    }
}

export default agencyMatchRed